import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavComponent } from './layout/nav/nav.component';
import { HomeComponent } from './pages/home/home.component';
import { BusinessComponent } from './pages/business/business.component';
import { CareersComponent } from './pages/careers/careers.component';
import { ContactComponent } from './pages/contact/contact.component';
import { FooterComponent } from './layout/footer/footer.component';
import { MapsItComponent } from './content/maps-it/maps-it.component';
import { MapsEnComponent } from './content/maps-en/maps-en.component';
import { ContactItComponent } from './content/contact-it/contact-it.component';
import { ContactEnComponent } from './content/contact-en/contact-en.component';
import { CappEngineeringItComponent } from './content/capp-engineering-it/capp-engineering-it.component';
import { CappEngineeringEnComponent } from './content/capp-engineering-en/capp-engineering-en.component';
import { HomeContentItComponent } from './content/home-content-it/home-content-it.component';
import { HomeContentEnComponent } from './content/home-content-en/home-content-en.component';
import { CarouselComponent } from './layout/carousel/carousel.component';
import { CarouselItemComponent } from './layout/carousel-item/carousel-item.component';
import { BuCompanyComponent } from './pages/bu-company/bu-company.component';
import { BuCompanyContentItComponent } from './content/bu-company-content-it/bu-company-content-it.component';
import { BuCompanyContentEnComponent } from './content/bu-company-content-en/bu-company-content-en.component';
import { ChemicalMineralFiberComponent } from './pages/chemical-mineral-fiber/chemical-mineral-fiber.component';
import { ChemicalMineralFiberContentItComponent } from './content/chemical-mineral-fiber-content-it/chemical-mineral-fiber-content-it.component';
import { ChemicalMineralFiberContentEnComponent } from './content/chemical-mineral-fiber-content-en/chemical-mineral-fiber-content-en.component';
import { InsulationComponent } from './pages/insulation/insulation.component';
import { InsulationContentItComponent } from './content/insulation-content-it/insulation-content-it.component';
import { InsulationContentEnComponent } from './content/insulation-content-en/insulation-content-en.component';
import { LogisticComponent } from './pages/logistic/logistic.component';
import { LogisticContentItComponent } from './content/logistic-content-it/logistic-content-it.component';
import { LogisticContentEnComponent } from './content/logistic-content-en/logistic-content-en.component';
import { OilGasComponent } from './pages/oil-gas/oil-gas.component';
import { OilGasCotentItComponent } from './content/oil-gas-cotent-it/oil-gas-cotent-it.component';
import { OilGasCotentEnComponent } from './content/oil-gas-cotent-en/oil-gas-cotent-en.component';
import { HandlingComponent } from './pages/handling/handling.component';
import { HandlingContentItComponent } from './content/handling-content-it/handling-content-it.component';
import { HandlingContentEnComponent } from './content/handling-content-en/handling-content-en.component';
import { SpecialComponent } from './pages/special/special.component';
import { SpecialContentItComponent } from './content/special-content-it/special-content-it.component';
import { SpecialContentEnComponent } from './content/special-content-en/special-content-en.component';
import { BusinessContentEnComponent } from './content/business-content-en/business-content-en.component';
import { BusinessContentItComponent } from './content/business-content-it/business-content-it.component';
import { ContactUsItComponent } from './content/contact-us-it/contact-us-it.component';
import { ContactUsEnComponent } from './content/contact-us-en/contact-us-en.component';
import { CareersEnComponent } from './content/careers-en/careers-en.component';
import { CareersItComponent } from './content/careers-it/careers-it.component';
import { ProcessingDataItComponent } from './content/processing-data-it/processing-data-it.component';
import { ProcessingDataEnComponent } from './content/processing-data-en/processing-data-en.component';
import { ProcessingDataComponent } from './pages/processing-data/processing-data.component';
import { ContactFooterItComponent } from './content/contact-footer-it/contact-footer-it.component';
import { ContactFooterEnComponent } from './content/contact-footer-en/contact-footer-en.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    HomeComponent,
    BusinessComponent,
    CareersComponent,
    ContactComponent,
    FooterComponent,
    MapsItComponent,
    MapsEnComponent,
    ContactItComponent,
    ContactEnComponent,
    CappEngineeringItComponent,
    CappEngineeringEnComponent,
    HomeContentItComponent,
    HomeContentEnComponent,
    CarouselComponent,
    CarouselItemComponent,
    BuCompanyComponent,
    BuCompanyContentItComponent,
    BuCompanyContentEnComponent,
    ChemicalMineralFiberComponent,
    ChemicalMineralFiberContentItComponent,
    ChemicalMineralFiberContentEnComponent,
    InsulationComponent,
    InsulationContentItComponent,
    InsulationContentEnComponent,
    LogisticComponent,
    LogisticContentItComponent,
    LogisticContentEnComponent,
    OilGasComponent,
    OilGasCotentItComponent,
    OilGasCotentEnComponent,
    HandlingComponent,
    HandlingContentItComponent,
    HandlingContentEnComponent,
    SpecialComponent,
    SpecialContentItComponent,
    SpecialContentEnComponent,
    BusinessContentEnComponent,
    BusinessContentItComponent,
    ContactUsItComponent,
    ContactUsEnComponent,
    CareersEnComponent,
    CareersItComponent,
    ProcessingDataItComponent,
    ProcessingDataEnComponent,
    ProcessingDataComponent,
    ContactFooterItComponent,
    ContactFooterEnComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule, 
    ReactiveFormsModule, ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
